import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useConsultarFatura } from "../../../hooks/queries/pagamento/useConsultarFatura/useConsultarFatura";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";
import { Tracking } from "../../../services/Tracking";

export const useTicketV2 = () => {
  const { uuidAgendamento } = useParams();
  const navigate = useNavigate();
  const stepIndicator = useAgendamentoStepIndicator();

  const { data: fatura, isError: isFaturaError } = useConsultarFatura(
    uuidAgendamento ?? "",
  );

  const pagamento = fatura?.content?.find(
    (f) => f.status === StatusPagamentoEnum.pending,
  );

  useEffect(() => {
    if (!isFaturaError) return;
    Tracking.error(
      "mapa:agendamento/pagamento/boleto:consultar-fatura-falhou",
    );
  }, [isFaturaError]);

  function acessarFatura() {
    navigate(`/agendamento/${uuidAgendamento}/fatura`);
  }

  return {
    stepIndicator,
    pagamento,
    acessarFatura,
  };
};
